import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/layout/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import About from "./pages/About";
import Pillar from "./pages/Pillar";
import Search from "./pages/Search";
import Annuaire from "./pages/Annuaire";
import ProfileDetail from "./pages/ProfileDetail";
import { BlogList, BlogPost } from "./pages/Blog";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import VerificationSent from "./pages/VerificationSent";
import ThankYou from "./pages/ThankYou";
import ServiceHowItWorks from "./pages/ServiceHowItWorks";
import Agenda from "./pages/Agenda";
import EventDetail from "./pages/EventDetail";
import GuidePratique from "./pages/GuidePratique";
import GuideDetail from "./pages/GuideDetail";
import RessourcesEnLigne from "./pages/RessourcesEnLigne";
import EspaceCeda from "./pages/EspaceCeda";
import FAQ from "./pages/FAQ";
import IciQuebec from "./pages/IciQuebec";
import EspacePublicite from "./pages/EspacePublicite";
import RequestService from "./pages/RequestService";
import ClientDashboard from "./pages/dashboard/ClientDashboard";
import ProviderDashboard from "./pages/dashboard/ProviderDashboard";
import AdminDashboard from "./pages/dashboard/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/je-metablis" element={<Pillar kind="settle" />} />
            {/* Legacy URL redirect (SEO preservation) */}
            <Route path="/je-minstalle" element={<Navigate to="/je-metablis" replace />} />
            <Route path="/j-entreprends" element={<Pillar kind="entrepreneur" />} />
            <Route path="/recherche" element={<Search />} />
            <Route path="/annuaire/:kind" element={<Annuaire />} />
            <Route path="/profil/:id" element={<ProfileDetail />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/temoignages" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/confidentialite" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />

            <Route path="/connexion" element={<Login />} />
            <Route path="/inscription" element={<Register />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
            <Route path="/verifier-email" element={<VerifyEmail />} />
            <Route path="/verification-envoyee" element={<VerificationSent />} />
            <Route path="/demande" element={<RequestService />} />
            <Route path="/je-cherche-un-service" element={<ServiceHowItWorks />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/agenda/:slug" element={<EventDetail />} />
            <Route path="/guide-pratique" element={<GuidePratique />} />
            <Route path="/guide-pratique/:slug" element={<GuideDetail />} />
            <Route path="/ressources-en-ligne" element={<RessourcesEnLigne />} />
            <Route path="/espace-ceda" element={<EspaceCeda />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/ici-quebec" element={<IciQuebec />} />
            <Route path="/espace-publicite" element={<EspacePublicite />} />
            <Route path="/merci" element={<ThankYou />} />

            <Route path="/dashboard/client" element={
              <ProtectedRoute><ClientDashboard /></ProtectedRoute>
            } />
            <Route path="/dashboard/provider" element={
              <ProtectedRoute roles={["professional", "entrepreneur", "organism", "client"]}><ProviderDashboard /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
            } />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
